import { OverlayView } from "@react-google-maps/api";
import { memo } from "react";
import styled from "styled-components";

const PulseMarker = styled.div`
  background-color: #fff;
  border: 2px solid var(--color-main);
  position: relative;
  width: ${({activeId, isActive}) => activeId && !isActive ? "30px" : "50px"};
  height: ${({activeId, isActive}) => activeId && !isActive ? "30px" : "50px"};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  animation: ${({isAnimated}) => isAnimated && "pulse 2s infinite"}; /* Animasyonu ekler */
  transform: translate(-50%, -50%);
  position: relative;

  .img {
    width: 100%;
    height: 100%;
    width: ${({type}) => type === "load" ? "85%" : "100%"};
    height: ${({type}) => type === "load" ? "85%" : "100%"};
    border-radius: 50%;
    object-fit: cover;

  }

  .type-container{
    position: absolute;
    bottom: -15px;
    right: -15px;
    width: ${({activeId, isActive}) => activeId && !isActive ? "23px" : "33px"};
    height: ${({activeId, isActive}) => activeId && !isActive ? "23px" : "33px"};
    z-index: 200 !important;
    border-radius: 50%;
    background-color: #fff;
    border: 1px dashed #000;
    display: flex;
    justify-content: center;
    align-items: center;

    .type-img{
      width: 65%;
      height: 65%;
      object-fit: cover;

    }
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.5); /* Başlangıç boyutu ve opaklığı */
    }
    70% {
      box-shadow: 0 0 0 20px rgba(255, 0, 0, 0); /* Genişler ve opaklık kaybolur */
    }
    100% {
      box-shadow: 0 0 0 0 rgba(255, 0, 0, 0); /* Biter */
    }
  }
`


const MemoizedOverlayHomepage = memo(({ position, typeImg, isAnimated, handleClick, userImg, type}) => (
    <OverlayView position={position} mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
      <PulseMarker onClick={handleClick} isAnimated={isAnimated} type={type}>
        <img src={userImg} alt="custom-marker" className="img" />
        {
          type !== "load" &&
          <div className="type-container">
            <img src={typeImg} className="type-img"/>
          </div>
        }
      </PulseMarker>
    </OverlayView>
  ));

export default MemoizedOverlayHomepage